import { __assign, __spreadArray } from "tslib";
import { FeeType, TaxType, FeeName } from '@wix/events-types';
import { WIX_FEE_RATE } from '../constants/event';
import { getCurrencyFormatConfig, getFormattedMoney } from '../price/formatter';
export var getAddedFee = function (invoice) { var _a; return (_a = invoice.fees) === null || _a === void 0 ? void 0 : _a.find(function (_a) {
    var type = _a.type;
    return isFeeAdded(type);
}); };
export var getIncludedFee = function (invoice) { var _a; return (_a = invoice.fees) === null || _a === void 0 ? void 0 : _a.find(function (_a) {
    var type = _a.type;
    return type === FeeType.FEE_INCLUDED;
}); };
export var isFeeAdded = function (type) { return [FeeType.FEE_ADDED, FeeType.FEE_ADDED_AT_CHECKOUT].includes(type); };
export var getPaidPlanDiscount = function (invoice) { var _a, _b; return (_b = (_a = invoice === null || invoice === void 0 ? void 0 : invoice.discount) === null || _a === void 0 ? void 0 : _a.discounts) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.paidPlan; }); };
export var getCouponDiscount = function (invoice) { var _a, _b; return (_b = (_a = invoice === null || invoice === void 0 ? void 0 : invoice.discount) === null || _a === void 0 ? void 0 : _a.discounts) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.coupon; }); };
export var getCouponDiscountCode = function (invoice) { var _a, _b; return (_b = (_a = getCouponDiscount(invoice)) === null || _a === void 0 ? void 0 : _a.coupon) === null || _b === void 0 ? void 0 : _b.code; };
export var getCouponDiscountName = function (invoice) { var _a, _b; return (_b = (_a = getCouponDiscount(invoice)) === null || _a === void 0 ? void 0 : _a.coupon) === null || _b === void 0 ? void 0 : _b.name; };
export var getCouponDiscountId = function (invoice) { var _a, _b; return (_b = (_a = getCouponDiscount(invoice)) === null || _a === void 0 ? void 0 : _a.coupon) === null || _b === void 0 ? void 0 : _b.couponId; };
export var getCouponDiscountAmount = function (invoice) { var _a; return (_a = getCouponDiscount(invoice)) === null || _a === void 0 ? void 0 : _a.amount; };
export var hasPaidPlanDiscount = function (invoice) { return Boolean(getPaidPlanDiscount(invoice)); };
export var hasCouponDiscount = function (invoice) { return Boolean(getCouponDiscount(invoice)); };
export var hasDiscount = function (invoice) { var _a, _b; return Boolean(Number((_b = (_a = invoice === null || invoice === void 0 ? void 0 : invoice.discount) === null || _a === void 0 ? void 0 : _a.amount) === null || _b === void 0 ? void 0 : _b.amount)); };
export var hasTax = function (invoice) { var _a; return Boolean(Number((_a = invoice.tax) === null || _a === void 0 ? void 0 : _a.amount.amount)); };
export var isTaxAdded = function (type) { return [TaxType.ADDED, TaxType.ADDED_AT_CHECKOUT].includes(type); };
export var hasAddedFee = function (invoice) { var _a; return Boolean(Number((_a = getAddedFee(invoice)) === null || _a === void 0 ? void 0 : _a.amount.amount)); };
export var hasIncludedFee = function (invoice) { var _a; return Boolean(Number((_a = getIncludedFee(invoice)) === null || _a === void 0 ? void 0 : _a.amount.amount)); };
export var hasSubtotal = function (invoice) {
    return hasDiscount(invoice) || hasTax(invoice) || hasAddedFee(invoice);
};
export var getPercentOffRate = function (paidPlan) { var _a, _b; return (_b = (_a = paidPlan.discount) === null || _a === void 0 ? void 0 : _a.percentOffRate) !== null && _b !== void 0 ? _b : '0'; };
export var getCheckoutSummary = function (invoice) {
    var _a;
    return ({
        subtotal: hasSubtotal(invoice) ? getFormattedMoney(invoice.subTotal) : null,
        paidPlanDiscount: hasPaidPlanDiscount(invoice) ? "-" + getFormattedMoney(getPaidPlanDiscount(invoice).amount) : null,
        discount: hasCouponDiscount(invoice) ? "-" + getFormattedMoney(getCouponDiscount(invoice).amount) : null,
        tax: hasTax(invoice) ? getFormattedMoney(invoice.tax.amount) : null,
        addedFee: hasAddedFee(invoice) ? getFormattedMoney(getAddedFee(invoice).amount) : null,
        includedFee: hasIncludedFee(invoice) ? getFormattedMoney(getIncludedFee(invoice).amount) : null,
        total: getFormattedMoney(invoice.grandTotal),
        ticketTotal: getFormattedMoney(invoice.subTotal),
        revenue: getFormattedMoney((_a = invoice.revenue) !== null && _a !== void 0 ? _a : {}),
    });
};
var roundPrice = function (amount, currencyCode) { var _a, _b; return amount.toFixed((_b = (_a = getCurrencyFormatConfig(currencyCode)) === null || _a === void 0 ? void 0 : _a.decimalDigits) !== null && _b !== void 0 ? _b : 2); };
export var getCurrencyFromTickets = function (ticketDefinitions) {
    return ticketDefinitions.length ? ticketDefinitions[0].price.currency : '';
};
export var getPreliminaryInvoice = function (ticketDefinitions, ticketDefinitionPicks, taxConfig, paidPlan) {
    var currency = getCurrencyFromTickets(ticketDefinitions);
    var items = getPreliminaryItems(ticketDefinitions, ticketDefinitionPicks, currency);
    var subTotalAmount = calculateSubTotal(items);
    var subTotal = getMoney(subTotalAmount, currency);
    var grandTotalAmount = Number(subTotal.amount);
    var _a = calculatePaidPlanDiscount(paidPlan, items, grandTotalAmount), discount = _a.discount, newItems = _a.items, updatedGrandTotalAmount = _a.grandTotalAmount;
    items = newItems;
    grandTotalAmount = updatedGrandTotalAmount;
    items = appendTaxAndFeesToItems(items, ticketDefinitions, taxConfig, currency);
    var taxAmount = calculateTax(items);
    var taxableAmount = calculateTaxable(items);
    var addedFeeAmount = calculateAddedFee(items);
    var includedFeeAmount = calculateIncludedFee(items);
    grandTotalAmount += addedFeeAmount;
    if (isTaxAdded(taxConfig === null || taxConfig === void 0 ? void 0 : taxConfig.type)) {
        grandTotalAmount = grandTotalAmount + taxAmount;
    }
    else if ((taxConfig === null || taxConfig === void 0 ? void 0 : taxConfig.type) === TaxType.INCLUDED) {
        subTotal.amount = roundPrice(Number(subTotal.amount) - taxAmount, currency);
    }
    var fees = [];
    if (addedFeeAmount) {
        // TODO: What to do here? (probably will need to change to FeeType.FEE_ADDED_AT_CHECKOUT after dashboard is changed to create with this FeeType)
        fees.push(getFee(FeeType.FEE_ADDED, getMoney(addedFeeAmount, currency)));
    }
    if (includedFeeAmount) {
        fees.push(getFee(FeeType.FEE_INCLUDED, getMoney(includedFeeAmount, currency)));
    }
    var grandTotal = getMoney(grandTotalAmount, currency);
    return {
        items: convertExtendedItemsToItems(items),
        discount: discount,
        subTotal: subTotal,
        grandTotal: grandTotal,
        tax: taxConfig
            ? __assign(__assign({}, taxConfig), { amount: getMoney(taxAmount, currency), taxable: getMoney(taxableAmount, currency) }) : null,
        fees: fees,
    };
};
var getEventCurrencyFromItems = function (items) { var _a, _b; return (_b = (_a = items === null || items === void 0 ? void 0 : items[0]) === null || _a === void 0 ? void 0 : _a.price.currency) !== null && _b !== void 0 ? _b : 'USD'; };
var orderItemsByPrice = function (items) {
    return __spreadArray([], items).sort(function (a, b) {
        var _a, _b, _c, _d;
        var aPrice = Number((_b = (_a = a === null || a === void 0 ? void 0 : a.price) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : 0);
        var bPrice = Number((_d = (_c = b === null || b === void 0 ? void 0 : b.price) === null || _c === void 0 ? void 0 : _c.amount) !== null && _d !== void 0 ? _d : 0);
        return bPrice - aPrice;
    });
};
var getAmountPercent = function (amount, percentOffRate, currencyCode) {
    return roundPrice((Number(amount) / 100) * Number(percentOffRate), currencyCode);
};
var ensureDiscountExistence = function (currentDiscount, defaultCurrency, currentTotalAmount) {
    return currentDiscount || {
        discounts: [],
        amount: { amount: '0', currency: defaultCurrency },
        afterDiscount: { amount: currentTotalAmount, currency: defaultCurrency },
    };
};
var addPaidPlanDiscount = function (discount, name, amount, currency, quantityDiscounted, rate) {
    var newDiscount = __assign(__assign({}, discount), { amount: __assign({}, discount.amount), afterDiscount: __assign({}, discount.afterDiscount), discounts: __spreadArray([], discount.discounts) });
    newDiscount.discounts.push({
        amount: { amount: amount, currency: currency },
        paidPlan: {
            name: name,
            percentDiscount: {
                quantityDiscounted: quantityDiscounted,
                rate: rate,
            },
        },
    });
    newDiscount.amount.amount = roundPrice(Number(newDiscount.amount.amount) + Number(amount), currency);
    newDiscount.afterDiscount.amount = roundPrice(Number(newDiscount.afterDiscount.amount) - Number(amount), currency);
    return newDiscount;
};
var reduceIndividualTicketPrices = function (ticketPrices, quantityDiscounted, singleDiscountAmount) {
    var newTicketPrices = __spreadArray([], ticketPrices);
    for (var i = 0; i < quantityDiscounted; i++) {
        newTicketPrices[i] -= Number(singleDiscountAmount);
    }
    return newTicketPrices;
};
var calculatePaidPlanDiscount = function (paidPlan, items, grandTotalAmount, discount) {
    if (!paidPlan) {
        return {
            items: items,
            discount: discount,
            grandTotalAmount: grandTotalAmount,
        };
    }
    var name = paidPlan.name, percentOffRate = paidPlan.discount.percentOffRate;
    var currency = getEventCurrencyFromItems(items);
    var orderedItems = orderItemsByPrice(items);
    var quantitySum = 0;
    var discountAmountSum = 0;
    var remainingCredits = paidPlan.remainingCredits;
    orderedItems.forEach(function (orderedItem) {
        if (remainingCredits) {
            var priceAmount = orderedItem.price.amount, totalAmount = orderedItem.total.amount;
            var singleItemDiscountAmount = getAmountPercent(priceAmount, percentOffRate, currency);
            var quantityDiscounted = Math.min(orderedItem.quantity, remainingCredits);
            remainingCredits -= quantityDiscounted;
            quantitySum += quantityDiscounted;
            orderedItem.ticketPrices = reduceIndividualTicketPrices(orderedItem.ticketPrices, quantityDiscounted, singleItemDiscountAmount);
            var totalItemPlanDiscountAmount = roundPrice(Number(singleItemDiscountAmount) * quantityDiscounted, currency);
            discountAmountSum += Number(totalItemPlanDiscountAmount);
            orderedItem.discount = ensureDiscountExistence(orderedItem.discount, currency, totalAmount);
            orderedItem.discount = addPaidPlanDiscount(orderedItem.discount, name, totalItemPlanDiscountAmount, currency, quantityDiscounted, getPercentOffRate(paidPlan));
        }
    });
    var grandTotalAfterDiscount = grandTotalAmount;
    if (quantitySum) {
        discount = ensureDiscountExistence(discount, currency, roundPrice(grandTotalAmount, currency));
        discount = addPaidPlanDiscount(discount, name, roundPrice(discountAmountSum, currency), currency, quantitySum, getPercentOffRate(paidPlan));
        grandTotalAfterDiscount = grandTotalAfterDiscount - Number(discountAmountSum);
    }
    return {
        items: items,
        discount: discount,
        grandTotalAmount: grandTotalAfterDiscount,
    };
};
var appendTaxAndFeesToItems = function (items, ticketDefinitions, taxConfig, currency) {
    return items.map(function (item) {
        var wixFeeConfig = ticketDefinitions.find(function (def) { return def.id === item.id; }).wixFeeConfig;
        var taxesAndFees = item.ticketPrices.map(function (ticketPrice) {
            var ticketTax = getPreliminaryTax(taxConfig, ticketPrice, currency);
            var subtotal = isTaxAdded(ticketTax === null || ticketTax === void 0 ? void 0 : ticketTax.type) ? ticketPrice + Number(ticketTax.amount.amount) : ticketPrice;
            var ticketFees = getPreliminaryFees(wixFeeConfig, subtotal, currency);
            return { tax: ticketTax, fees: ticketFees };
        });
        var _a = taxesAndFees.reduce(function (_a, _b) {
            var taxItem = _a.tax, feesItem = _a.fees;
            var taxSum = _b.tax, feesSum = _b.fees;
            if (taxSum) {
                taxSum.taxable.amount = roundPrice(Number(taxSum.taxable.amount) + Number(taxItem.taxable.amount), currency);
                taxSum.amount.amount = roundPrice(Number(taxSum.amount.amount) + Number(taxItem.amount.amount), currency);
            }
            if (feesSum.length) {
                feesSum[0].amount.amount = roundPrice(Number(feesSum[0].amount.amount) + Number(feesItem[0].amount.amount), currency);
            }
            return { tax: taxSum, fees: feesSum };
        }), tax = _a.tax, fees = _a.fees;
        return __assign(__assign({}, item), { tax: tax,
            fees: fees });
    });
};
var convertExtendedItemsToItems = function (extendedItems) {
    return extendedItems.map(function (extendedItem) {
        var newItem = {};
        var bannedKeys = ['ticketPrices'];
        Object.keys(extendedItem).forEach(function (key) {
            if (!bannedKeys.includes(key)) {
                // @ts-expect-error
                newItem[key] = extendedItem[key];
            }
        });
        return newItem;
    });
};
var getPreliminaryItems = function (ticketDefinitions, ticketDefinitionPicks, currency) {
    var picks = Object.entries(ticketDefinitionPicks).filter(function (_a) {
        var quantity = _a[1];
        return Boolean(quantity);
    });
    return picks.map(function (_a) {
        var ticketDefId = _a[0], quantity = _a[1];
        var _b = ticketDefinitions.find(function (def) { return def.id === ticketDefId; }), id = _b.id, name = _b.name, price = _b.price;
        return {
            id: id,
            name: name,
            price: price,
            quantity: quantity,
            total: getMoney(Number(price.amount) * quantity, currency),
            ticketPrices: Array(quantity).fill(Number(price.amount)),
        };
    });
};
export var getPreliminaryTax = function (taxConfig, total, currency) {
    if (taxConfig) {
        var tax = {
            type: taxConfig.type,
            name: taxConfig.name,
            rate: taxConfig.rate,
        };
        var rateAmount = Number(tax.rate);
        if (isTaxAdded(tax.type)) {
            tax.taxable = getMoney(total, currency);
            tax.amount = getMoney((total * rateAmount) / 100, currency);
        }
        else {
            tax.taxable = getMoney((total * 100) / (100 + rateAmount), currency);
            tax.amount = getMoney(total - Number(tax.taxable.amount), currency);
        }
        return tax;
    }
    return null;
};
var getPreliminaryFees = function (wixFeeConfig, total, currency) {
    return wixFeeConfig ? [getFee(wixFeeConfig.type, getMoney(total * WIX_FEE_RATE, currency))] : [];
};
var calculateSubTotal = function (items) {
    return items.reduce(function (amount, item) { return amount + Number(item.total.amount); }, 0);
};
var calculateTax = function (items) {
    return items.reduce(function (amount, item) { var _a; return amount + Number((_a = item.tax) === null || _a === void 0 ? void 0 : _a.amount.amount); }, 0);
};
var calculateTaxable = function (items) {
    return items.reduce(function (amount, item) { var _a; return amount + Number((_a = item.tax) === null || _a === void 0 ? void 0 : _a.taxable.amount); }, 0);
};
var calculateAddedFee = function (items) {
    return items.reduce(function (amount, item) { var _a; return (isFeeAdded((_a = item.fees[0]) === null || _a === void 0 ? void 0 : _a.type) ? amount + Number(item.fees[0].amount.amount) : amount); }, 0);
};
var calculateIncludedFee = function (items) {
    return items.reduce(function (amount, item) { var _a; return ((_a = item.fees[0]) === null || _a === void 0 ? void 0 : _a.type) === FeeType.FEE_INCLUDED ? amount + Number(item.fees[0].amount.amount) : amount; }, 0);
};
var getMoney = function (amount, currency) { return ({
    amount: roundPrice(amount, currency),
    currency: currency,
}); };
var getFee = function (type, amount) { return ({
    type: type,
    amount: amount,
    name: FeeName.WIX_FEE,
    rate: (WIX_FEE_RATE * 100).toString(),
}); };
export var getTaxLabel = function (invoice) {
    return hasTax(invoice) ? invoice.tax.name + " (" + invoice.tax.rate + "%)" : null;
};
export var getMembershipLabel = function (invoice) {
    return hasPaidPlanDiscount(invoice) ? getPaidPlanDiscount(invoice).paidPlan.name : null;
};
export var getPaidPlanPercentDiscount = function (invoice) {
    return hasPaidPlanDiscount(invoice) ? Number(getPaidPlanDiscount(invoice).paidPlan.percentDiscount.rate).toString() : null;
};
//# sourceMappingURL=checkout.js.map